import BackButton from 'Components/BackButton'
import Breadcrumbs from 'Components/Breadcrumbs'
import PageTitle from 'Components/PageTitle'
import CodespaceForm from 'Services/ControlDataManagement/Features/Codespace/Components/CodespaceForm'
import { useCreateSingleCodespaceMutation } from 'Services/ControlDataManagement/Features/Codespace/codespaceApi'
import { usePreviousLocation } from 'Util/Context/previousLocationContext'
import { CONTROL_DATA_MANAGEMENT_ROOT_URL } from 'Util/constants'
import { Box, Grid } from '@mui/material'
import { t } from 'ttag'

export default function CodespaceCreatePage() {
  const baseUrl = `${CONTROL_DATA_MANAGEMENT_ROOT_URL}/codespaces`
  const previousLocation = usePreviousLocation(baseUrl)
  const [, { isLoading: submitLoading }] = useCreateSingleCodespaceMutation()

  const breadcrumbs = [
    {
      title: t`Home`,
      link: CONTROL_DATA_MANAGEMENT_ROOT_URL
    },
    {
      title: t`Codespaces`,
      link: baseUrl
    },
    {
      title: t`Create new codespace`
    }
  ]

  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} mb={4}>
        <Grid size={12}>
          <Breadcrumbs items={breadcrumbs} />
          <BackButton label={t`Back`} link={previousLocation} />
          <PageTitle>{t`Create new codespace`}</PageTitle>
        </Grid>
      </Grid>
      <CodespaceForm successBaseUrl={previousLocation} submitLoading={submitLoading} />
    </Box>
  )
}
